DialogController = App.loadClass 'core::Angular/DialogController'

class exports.LocaleController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, userData, locales, @service) ->
        super(@scope, @transitions, @modalInstance)

        @scope.title = 'Set Locale'
        @scope.user = userData
        @scope.new_locale = null
        @scope.received_data = userData? and locales?
        @scope.locale_collection = _.chunk locales, 3

        @scope.changeLocale = (locale) =>
            @scope.new_locale = locale.id
            @scope.user.locales_id = locale.id

    save: () =>
        @scope.setAlert({ msg: 'Updating Locale...', type: 'info' })

        @service.setLocale(@scope.new_locale).then (response) =>
            @scope.new_locale = null
            @closeWithAlert response.data.status, response.data.data

            location.reload()
